const Reducer = (state, action) => {
    switch (action.type) {
        case 'USER_HAS_TO_SIGN_UP':
            return {
                ...state,
                signUpSource: action.payload
            };
        default:
            break;
    }
}

export default Reducer;